import { axiosInstance as axios } from './index';

export const getCurrentUser = async (id: string) => {
  const { data } = await axios.get(`/users/${id}`);
  return data;
};

export type CheckUserStatus =
  | 'NOT_FOUND'
  | 'SOCIAL_LOGIN'
  | 'OK'
  | 'NOT_VERIFIED';

type WithSocialLoginProviders = {
  socialLoginProviders: string[];
};

export type CheckUserResponse =
  | { status: 'NOT_FOUND' }
  | { status: 'NOT_VERIFIED' }
  | ({ status: 'OK' } & WithSocialLoginProviders)
  | ({ status: 'SOCIAL_LOGIN' } & WithSocialLoginProviders);

const checkUserByEmail = async (email: string): Promise<CheckUserResponse> => {
  const { data } = await axios.post<CheckUserResponse>('/auth/check-user', {
    email,
  });
  return data;
};

export const checkUserForForgotPassword = async (
  email: string,
): Promise<CheckUserResponse> => {
  return checkUserByEmail(email);
};

export const checkUserForSignIn = async (
  email: string,
): Promise<CheckUserResponse> => {
  return checkUserByEmail(email);
};
